__turbopack_context__.v({
  "flake": "Snow-module__0ELkXq__flake",
  "root": "Snow-module__0ELkXq__root",
});
